import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { User, Lock, ArrowLeft, AlertCircle, Mail, KeyRound, Eye, EyeOff } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { db } from '../firebaseConfig';
import { collection, getDocs, query, where } from 'firebase/firestore';
import axios from 'axios';
import './Register.css'; // Tasarımın tutarlı kalması için mevcut register-css'i kullanıyoruz

const Giris = () => {
  const [usernameOrEmail, setUsernameOrEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // --- ŞİFREMİ UNUTTUM / OTP STATE'LERİ ---
  const [viewMode, setViewMode] = useState('login'); // 'login' | 'forgot' | 'reset' | 'otp_verify'
  const [forgotEmail, setForgotEmail] = useState('');
  const [resetCode, setResetCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordConfirm, setNewPasswordConfirm] = useState('');
  
  // Şifre Göster/Gizle Durumları
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  
  const { loginWithCredentials, loginWithGoogle } = useAuth();
  const navigate = useNavigate();

  // --- GOOGLE İLE OYUNCU GİRİŞİ ---
  const handleGoogleAuth = async () => {
    setError('');
    setLoading(true);
    try {
      await loginWithGoogle();
      alert("✅ Google ile Giriş Başarılı!");
      navigate('/profile');
    } catch (error) {
      console.error("Google Auth Error:", error);
      setError("Google ile giriş başarısız oldu: " + (error.message || error));
    } finally {
      setLoading(false);
    }
  };

  // --- NORMAL GİRİŞ (SÜPER ADMİN / TESİS SAHİBİ) ---
  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const safeInput = usernameOrEmail.trim().toLowerCase();

    try {
      // 1. Süper Admin Kontrolü (Hardcoded/Offline hesap)
      if (safeInput === 'suerdemahmetsami7@gmail.com' || safeInput === 'sami') {
        if (password === 'Ahmet19o7!..') {
          localStorage.setItem("superAdmin", "true");
          alert("Hoş geldiniz, Süper Admin Girişi Başarılı!");
          window.location.href = "/superadmin";
          return;
        } else {
          setError("Hatalı şifre!");
          setLoading(false);
          return;
        }
      }

      // 2. Tesis Sahibi (Yönetici) Giriş Testi (Firestore)
      const qTesis = query(collection(db, "tesisler"), where("username", "==", safeInput));
      const qTesisSnap = await getDocs(qTesis);
      let tesisDoc = null;

      if (!qTesisSnap.empty) {
        tesisDoc = qTesisSnap.docs[0];
      } else {
        // E-posta ile de kontrol et
        const qTesisEmail = query(collection(db, "tesisler"), where("email", "==", safeInput));
        const qTesisEmailSnap = await getDocs(qTesisEmail);
        if (!qTesisEmailSnap.empty) {
          tesisDoc = qTesisEmailSnap.docs[0];
        }
      }

      if (tesisDoc) {
        const tesisData = { id: tesisDoc.id, ...tesisDoc.data() };
        if (tesisData.status === "pending") {
          setError("Saha başvurunuz Süper Admin onayındadır. Onaylanmadan giriş yapılamaz.");
          setLoading(false);
          return;
        }

        // Tesis şifre eşleştirmesi
        if (tesisData.password === password) {
          const session = { userId: tesisDoc.id, user: tesisData, timestamp: Date.now() };
          localStorage.setItem('sahalive_session', JSON.stringify(session));
          alert("Giriş Başarılı! Yönetici Paneline yönlendiriliyorsunuz.");
          window.location.href = "/admin-dashboard";
          return;
        } else {
          setError("Hatalı yönetici şifresi!");
          setLoading(false);
          return;
        }
      }

      // 3. Veritabanındaki Diğer Süper Adminleri ve Normal Oyuncuları Giriş Testi (MongoDB)
      try {
        const loggedUser = await loginWithCredentials(usernameOrEmail, password);
        
        if (loggedUser && (loggedUser.role === 'superadmin' || loggedUser.user?.role === 'superadmin')) {
          localStorage.setItem("superAdmin", "true");
          alert("Hoş geldiniz, Süper Admin Girişi Başarılı!");
          window.location.href = "/superadmin";
          return;
        }

        // Eğer giriş başarılı olduysa (Oyuncu/User)
        alert("Giriş Başarılı! Profilinize yönlendiriliyorsunuz.");
        navigate('/profile');
      } catch (err) {
        setError(err.response?.data?.error || "Kullanıcı adı veya şifre hatalı!");
      }

    } catch (err) {
      console.error(err);
      setError("Giriş sırasında hata oluştu!");
    } finally {
      setLoading(false);
    }
  };

  // --- DOĞRULAMA KODU (OTP) KONTROLÜ (SÜPER ADMİN / TESİS SAHİBİ) ---
  // --- ŞİFRE SIFIRLAMA KODU GÖNDER ---
  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/auth/forgot-password`, {
        email: forgotEmail
      });
      alert(response.data.message || "Sıfırlama kodu e-postanıza gönderildi!");
      if (response.data.debugCode) {
        console.log("🔒 [DEVELOPMENT ONLY] Reset Password Code:", response.data.debugCode);
      }
      setViewMode('reset');
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.error || "Kod gönderilemedi. Lütfen geçerli bir e-posta adresi girdiğinizden emin olun.");
    } finally {
      setLoading(false);
    }
  };

  // --- YENİ ŞİFREYİ KAYDET ---
  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError('');

    if (newPassword !== newPasswordConfirm) {
      setError("Şifreler eşleşmiyor!");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/auth/reset-password`, {
        email: forgotEmail,
        code: resetCode,
        newPassword
      });
      alert(response.data.message || "Şifreniz başarıyla sıfırlandı! Giriş yapabilirsiniz.");
      
      // State temizliği
      setForgotEmail('');
      setResetCode('');
      setNewPassword('');
      setNewPasswordConfirm('');
      setViewMode('login');
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.error || "Şifre sıfırlama başarısız oldu. Kodu kontrol edin.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-container">
      <div className="register-box" style={{maxWidth: '420px'}}>
        
        {/* --- SOL ÜST KÖŞEYE ANA SAYFAYA DÖN BUTONU --- */}
        <Link to="/" className="back-button-top">
             <ArrowLeft size={20} /> Ana Sayfa
         </Link>

        {viewMode === 'login' && (
          <>
            <div className="header-section text-center mb-4">
              <h2>SahaLive Giriş</h2>
              <p>Oyuncu veya İşletme Hesabınızla Giriş Yapın</p>
            </div>

            {error && (
              <div className="alert alert-danger d-flex align-items-center gap-2 py-2 px-3 rounded-3" style={{ fontSize: '14px' }}>
                <AlertCircle size={16} />
                <span>{error}</span>
              </div>
            )}

            <form onSubmit={handleLogin}>
              <div className="input-group full-width mb-3">
                <User size={18} />
                <input 
                  type="text" 
                  placeholder="Kullanıcı Adı veya E-Posta" 
                  value={usernameOrEmail}
                  onChange={(e) => setUsernameOrEmail(e.target.value)}
                  required 
                />
              </div>

              <div className="input-group full-width mb-2" style={{ position: 'relative' }}>
                <Lock size={18} />
                <input 
                  type={showPassword ? "text" : "password"} 
                  placeholder="Şifre" 
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required 
                  style={{ paddingRight: '45px' }}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: 'absolute',
                    right: '15px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    cursor: 'pointer',
                    color: '#a0aec0',
                    zIndex: 10,
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>

              {/* Şifremi Unuttum Bağlantısı */}
              <div className="text-end mb-3">
                <button 
                  type="button" 
                  onClick={() => { setViewMode('forgot'); setError(''); }} 
                  className="btn btn-link text-decoration-none p-0 text-muted small fw-semibold"
                >
                  Şifremi Unuttum
                </button>
              </div>

              <button type="submit" className="submit-btn w-100" disabled={loading}>
                {loading ? "GİRİŞ YAPILIYOR..." : "GİRİŞ YAP"}
              </button>
            </form>

            {/* OYUNCULAR İÇİN GOOGLE GİRİŞ BUTONU */}
            <div className="divider text-center my-3 text-muted">
              <span>veya</span>
            </div>

            <button 
              type="button" 
              onClick={handleGoogleAuth} 
              className="btn btn-outline-dark rounded-pill w-100 fw-bold py-2 d-flex align-items-center justify-content-center gap-2 shadow-sm mb-3"
              disabled={loading}
              style={{ minHeight: '45px' }}
            >
              <img src="https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_%22G%22_logo.svg" alt="Google" style={{ width: '18px' }} />
              Google ile Oyuncu Girişi
            </button>

            <div className="footer-link text-center mt-3">
              <p>Hesabınız yok mu? <Link to="/kayit" className="fw-bold text-primary text-decoration-none">Hemen Kaydolun</Link></p>
            </div>
          </>
        )}


        {viewMode === 'forgot' && (
          <>
            <div className="header-section text-center mb-4">
              <h2>Şifremi Unuttum</h2>
              <p>Hesabınıza ait e-posta adresini girerek şifre sıfırlama kodu talep edin.</p>
            </div>

            {error && (
              <div className="alert alert-danger d-flex align-items-center gap-2 py-2 px-3 rounded-3" style={{ fontSize: '14px' }}>
                <AlertCircle size={16} />
                <span>{error}</span>
              </div>
            )}

            <form onSubmit={handleForgotPassword}>
              <div className="input-group full-width mb-4">
                <Mail size={18} />
                <input 
                  type="email" 
                  placeholder="E-Posta Adresiniz" 
                  value={forgotEmail}
                  onChange={(e) => setForgotEmail(e.target.value)}
                  required 
                />
              </div>

              <button type="submit" className="submit-btn w-100 mb-3" disabled={loading}>
                {loading ? "KOD GÖNDERİLİYOR..." : "KOD GÖNDER"}
              </button>

              <button 
                type="button" 
                onClick={() => { setViewMode('login'); setError(''); }} 
                className="btn btn-outline-secondary rounded-pill w-100 fw-bold py-2 small"
              >
                Giriş Ekranına Dön
              </button>
            </form>
          </>
        )}

        {viewMode === 'reset' && (
          <>
            <div className="header-section text-center mb-4">
              <h2>Yeni Şifre Belirle</h2>
              <p>E-postanıza gönderilen 6 haneli doğrulama kodunu ve yeni şifrenizi girin.</p>
            </div>

            {error && (
              <div className="alert alert-danger d-flex align-items-center gap-2 py-2 px-3 rounded-3" style={{ fontSize: '14px' }}>
                <AlertCircle size={16} />
                <span>{error}</span>
              </div>
            )}

            <form onSubmit={handleResetPassword}>
              <div className="input-group full-width mb-3">
                <Mail size={18} style={{ opacity: 0.5 }} />
                <input 
                  type="email" 
                  value={forgotEmail}
                  disabled 
                  style={{ background: '#f1f3f5', color: '#868e96' }}
                />
              </div>

              <div className="input-group full-width mb-3">
                <KeyRound size={18} />
                <input 
                  type="text" 
                  placeholder="6 Haneli Doğrulama Kodu" 
                  value={resetCode}
                  onChange={(e) => setResetCode(e.target.value)}
                  required 
                />
              </div>

              <div className="input-group full-width mb-3" style={{ position: 'relative' }}>
                <Lock size={18} />
                <input 
                  type={showNewPassword ? "text" : "password"} 
                  placeholder="Yeni Şifre" 
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required 
                  style={{ paddingRight: '45px' }}
                />
                <button
                  type="button"
                  onClick={() => setShowNewPassword(!showNewPassword)}
                  style={{
                    position: 'absolute',
                    right: '15px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    cursor: 'pointer',
                    color: '#a0aec0',
                    zIndex: 10,
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  {showNewPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>

              <div className="input-group full-width mb-4" style={{ position: 'relative' }}>
                <Lock size={18} />
                <input 
                  type={showConfirmPassword ? "text" : "password"} 
                  placeholder="Yeni Şifre Tekrar" 
                  value={newPasswordConfirm}
                  onChange={(e) => setNewPasswordConfirm(e.target.value)}
                  required 
                  style={{ paddingRight: '45px' }}
                />
                <button
                  type="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  style={{
                    position: 'absolute',
                    right: '15px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    cursor: 'pointer',
                    color: '#a0aec0',
                    zIndex: 10,
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>

              <button type="submit" className="submit-btn w-100 mb-3" disabled={loading}>
                {loading ? "ŞİFRE GÜNCELLENİYOR..." : "ŞİFREYİ GÜNCELLE"}
              </button>

              <button 
                type="button" 
                onClick={() => { setViewMode('login'); setError(''); }} 
                className="btn btn-outline-secondary rounded-pill w-100 fw-bold py-2 small"
              >
                Giriş Ekranına Dön
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default Giris;